import styled, { css } from 'styled-components'

export const Tip = styled.div`
    font-size: var(--font-size-sm);
    color: var(--color-gray-400);
    margin: 8px 0;
`

export const MessageTemplatePreviewer = styled.div`
    padding: 12px;
    border-radius: 6px;
    background-color: var(--color-gray-100);
    font-size: var(--font-size-normal);
    margin-top: 18px;
`

export const MessageTemplatePreviewerHeader = styled.div`
    color: var(--color-gray-400);
    margin-bottom: 8px;
`

export const MessageTemplatePreviewerContent = styled.div``

export const VariableItem = styled.div`
    margin-bottom: 12px;
`

export const VariableTitle = styled.div`
    margin-bottom: 8px;
`

export const AuthConfig = styled.div`
    padding: 0 16px 4px 16px;
    /* border-bottom: 1px solid var(--color-gray-200); */
`
